import type { ReactNode } from "react";
import { useMobile } from "../features/maintenance-mobile/mobile-ui";

interface Props {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  badge?: ReactNode;
}

export function PageHeader({ title, subtitle, actions, badge }: Props) {
  // Na casca mobile o título já está no cabeçalho da casca: aqui sobram o selo
  // e as ações, numa linha que rola para o lado em vez de espremer a tela.
  if (useMobile()) {
    if (!actions && !badge) return null;
    return (
      <div className="-mx-4 mb-1 flex items-center gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {badge}
        {actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
      </div>
    );
  }
  return (
    <div className="flex items-start justify-between gap-4 mb-6">
      <div>
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
          {badge}
        </div>
        {subtitle && <p className="mt-1 text-sm text-gray-500">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}
